/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css } from "@panda/css";

export const styled = css({
	flex: "50%",
	maxWidth: "44%",
	display: "flex",
	alignItems: "center",
	zIndex: 2,

	lgDown: {
		maxWidth: "100%",
	},

	"& .title-desc-buttons": {
		alignItems: "flex-start",
		gap: "0",
		lg: {
			marginTop: "eds.dimension.24",
			"&.has-top-wrap": {
				marginTop: "0",
			},
		},
	},

	"& .title": {
		flexBasis: "60%",
		marginBottom: "eds.dimension.24",
		smDown: {
			marginBottom: "eds.dimension.16",
		},
	},

	"& .desc-buttons": {
		alignItems: "flex-start",
		gap: "eds.dimension.32",
		flexBasis: "40%",
		lgDown: {
			gap: "eds.dimension.24",
		},
	},

	"& .title .cosmos-text.heading": {
		lineClamp: "3",
		overflow: "hidden",
		xlDown: {
			textStyle: "heading2XL",
		},
		smDown: {
			textStyle: "headingXL",
		},
	},

	"& .cosmos-text.paragraph": {
		xxlDown: {
			textStyle: "paragraphMD",
		},
	},

	"& .button-list": {
		xsOnly: {
			flexDirection: "column",
			alignItems: "flex-start",
		},
	},
});
